export var BridgeInjectables = /*#__PURE__*/ function(BridgeInjectables) {
    BridgeInjectables["AuthBridgeService"] = "AuthBridgeService";
    return BridgeInjectables;
}({});
export var HostType = /*#__PURE__*/ function(HostType) {
    HostType["FBO"] = "FBO";
    HostType["PORTALS"] = "PORTALS";
    return HostType;
}({});
